import http from "./httpService";
import auth from "./authService";

const headers = {
  headers: {
    "Content-Type": "multipart/form-data",
  },
};

function supplierStoreUrl(id) {
  const pVisaId = localStorage.getItem("roomId");

  if (id) return `/v1/projects/${pVisaId}/ledgers/${id}`;
  else return `/v1/projects/${pVisaId}/ledgers`;
}

export function getAllLedgers(data) {
  const pVisaId = localStorage.getItem("roomId");
  //return http.post(supplierStoreUrl(), data);
  return http.post(`/v1/projects/${pVisaId}/generate-ledgers`, data);
  //return http.get(supplierStoreUrl());
}

export function saveEntryType(supplier) {
  return http.post(
    `/v1/project-ledger/${supplier.id}/update-entry-type`,
    supplier
  );
}

export function deleteLedger(supplierId) {
  return http.delete(supplierStoreUrl(supplierId));
}

export function saveSingle(supplier) {
  return http.post(supplierStoreUrl(), supplier, headers);
}

export function updateSingle(supplier) {
  return http.put(supplierStoreUrl(supplier.id), supplier);
}

export function updateSingleStatus(supplier) {
  return http.get(
    `/v1/projects/${auth.getCurrentUser().company_id}/ledgers/${
      supplier.id
    }/status`
  );
}

export function getLedger(supplierId) {
  return http.get(supplierStoreUrl(supplierId));
}
